import RestService from "../services/rest.service";

export const getInbox = () => (dispatch) => {
  return new Promise((resolve, reject) => {
    RestService.get(`app/inbox`).then(
      (response) => {
        let data = response.data.data
        dispatch({
          type: "SET_INBOX_LIST",
          payload: data
        });
        resolve()
      },
      (error) => {
        const message =
          (error.response &&
            error.response.data &&
            error.response.data.message) ||
          error.message ||
          error.toString();
        dispatch({
          type: "SET_MESSAGE",
          payload: message,
        });
        dispatch({
          type: "SET_INBOX_LIST",
          payload: {}
        });
        reject()
      }
    );
  })
};

export const getInboxLimit = () => (dispatch) => {
  return new Promise((resolve, reject) => {
    RestService.get(`app/inbox?limit=5`).then(
      (response) => {
        let data = response.data.data
        dispatch({
          type: "SET_INBOX_LIST",
          payload: data
        });
        resolve()
      },
      (error) => {
        const message =
          (error.response &&
            error.response.data &&
            error.response.data.message) ||
          error.message ||
          error.toString();
        dispatch({
          type: "SET_MESSAGE",
          payload: message,
        });
        dispatch({
          type: "SET_INBOX_LIST",
          payload: {}
        });
        reject()
      }
    );
  })
};

export const patchReadInbox = (serial) => (dispatch) => {
  return new Promise((resolve, reject) => {
    RestService.patch(`app/inbox/read/${serial}`).then(
      (response) => {
        resolve()
      },
      (error) => {
        const message =
          (error.response &&
            error.response.data &&
            error.response.data.message) ||
          error.message ||
          error.toString();
        dispatch({
          type: "SET_MESSAGE",
          payload: message,
        });
        reject()
      }
    );
  })
};

export const getInboxDetail = (serial) => (dispatch) => {
  return new Promise((resolve, reject) => {
    RestService.get(`app/inbox/${serial}`).then(
      (response) => {
        let data = response.data.data
        dispatch({
          type: "SET_INBOX_DETAIL",
          payload: data
        });
        resolve(data)
      },
      (error) => {
        const message =
          (error.response &&
            error.response.data &&
            error.response.data.message) ||
          error.message ||
          error.toString();
        dispatch({
          type: "SET_MESSAGE",
          payload: message,
        });
        dispatch({
          type: "SET_INBOX_DETAIL",
          payload: {}
        });
        reject()
      }
    );
  })
};

export const postWorkflowSubmit = (data) => (dispatch) => {
  return new Promise((resolve, reject) => {
    RestService.post(`app/workflow/rubric/submit`, data).then(
      (response) => {
        resolve()
      },
      (error) => {
        const message =
          (error.response &&
            error.response.data &&
            error.response.data.message) ||
          error.message ||
          error.toString();
        dispatch({
          type: "SET_MESSAGE",
          payload: message,
        });
        reject()
      }
    );
  })
};

export const postWorkflowReject = (data) => (dispatch) => {
  return new Promise((resolve, reject) => {
    RestService.post(`app/workflow/rubric/reject`, data).then(
      (response) => {
        resolve()
      },
      (error) => {
        const message =
          (error.response &&
            error.response.data &&
            error.response.data.message) ||
          error.message ||
          error.toString();
        dispatch({
          type: "SET_MESSAGE",
          payload: message,
        });
        reject()
      }
    );
  })
};

export const postWorkflowCancel = (data) => (dispatch) => {
  return new Promise((resolve, reject) => {
    RestService.post(`app/workflow/rubric/cancel`, data).then(
      (response) => {
        resolve()
      },
      (error) => {
        const message =
          (error.response &&
            error.response.data &&
            error.response.data.message) ||
          error.message ||
          error.toString();
        dispatch({
          type: "SET_MESSAGE",
          payload: message,
        });
        reject()
      }
    );
  })
};

export const postWorkflowRequest = (data) => (dispatch) => {
  return new Promise((resolve, reject) => {
    RestService.post(`app/workflow/rubric/request`, data).then(
      (response) => {
        resolve();
      },
      (error) => {
        const message =
          (error.response &&
            error.response.data &&
            error.response.data.message) ||
          error.message ||
          error.toString();
        dispatch({
          type: "SET_MESSAGE",
          payload: message,
        });
        reject();
      }
    );
  });
}